import Banner from '@/components/banner'
import FeaturedServicesCard from '@/components/card/featuredServicesCard'
import Plans from '@/components/plans/plans'
import { Trophy, Search, Rocket, Handshake } from 'lucide-react'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/nbn')({
  component: RouteComponent,
})

const cardData = [
  {
    title: 'High-performance speeds',
    description:
      'The nbn™ network will help you enjoy the fastest speeds possible in your area.',
    icon: (
      <Trophy className="text-icon-primary mb-4" size={120} strokeWidth={1.5} />
    ),
  },
  {
    title: 'No limits',
    description:
      'Enjoy the freedom of unlimited data no ﬁxed data plans, no setup fees and no peak or oﬀpeak limits.',
    icon: (
      <Rocket className="text-icon-primary mb-4" size={120} strokeWidth={1.5} />
    ),
  },
  {
    title: 'Support\n365 days a year',
    description:
      'Any time of the day or night, including public holidays, we’re here to provide technical support if you need it.',
    icon: (
      <Handshake
        className="text-icon-primary mb-4"
        size={120}
        strokeWidth={1.5}
      />
    ),
  },
]

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/banner.jpg"
        containerStyle="banner-gradient min-h-[450px] lg:min-h-[520px]"
      >
        <div className="relative px-4 z-10 h-full w-full max-w-[1380px] mx-auto my-auto">
          <p className="text-4xl font-bold text-white max-w-[440px] mb-6">
            Unlimited nbn™ plans starting from $63.63
          </p>
          <Link to="/sign-up" className="btn btn-secondary-darken">
            Start Here
          </Link>
        </div>
      </Banner>

      <div className="action-banner">
        <div className="breakpoint-container flex justify-center">
          <Link
            to="/sign-up"
            className="!no-underline inline-flex flex-row items-center gap-20 rounded-full border-2 py-3 px-8 text-white"
          >
            <p className="text-[2rem] font-semibold">Check your address here</p>
            <Search size={45} strokeWidth={1.5} />
          </Link>
        </div>
      </div>

      <div className="content-container">
        <div className="breakpoint-container flex flex-col">
          <h1 className="content-title self-center">Why {WHOLESALERNAME}?</h1>
          <div className="card-row-container flex-wrap lg:flex-nowrap">
            {cardData.map((data, index) => (
              <FeaturedServicesCard
                key={index}
                containerStyle="md:max-w-[48%] lg:max-w-none"
                cardData={data}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="content-container bg-golden-to-orange">
        <div className="breakpoint-container relative z-10">
          <h1 className="content-title self-center text-white">
            Choose the plan that is right for you
          </h1>
          <Plans />
        </div>
      </div>
    </>
  )
}
